import React from 'react';

export default function SectionAnchor({ id, label, title }) {
  return (
    <section id={id} className="bg-[#0F1C40] text-[#F1EDE4] pt-32 pb-8 lg:pt-40 lg:pb-12 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span className="text-[11px] font-mono uppercase tracking-widest text-[#4ECDC4]">{label}</span>
            </div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="text-4xl lg:text-6xl xl:text-7xl leading-[0.98] tracking-tight font-serif italic text-[#F1EDE4]">
              {title}
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
}
